<template>
  <div
       v-cloak
       v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <div class="login-container">

      <div class="login">
        <h1>
          Golden PIPE
          <span v-if="['qa','dev','local'].includes(environment)">
          To {{environment.toUpperCase()}} Site </span></h1>
        <h4 style="text-align: center;">
          Select a role to login Golden PIPE for:  {{username}}</h4>
        <br>
        <el-form class="ant-form ant-form-horizontal login-roles-item">

          <el-radio-group v-model="currentRole" @change="changeCurrent">
            <template  v-for="(itemRole, index) in roleList" >
              <el-radio  size ='midddle' :label="itemRole">{{itemRole}}</el-radio>
            </template>
          </el-radio-group>

        </el-form>
        <br>
        <div style="text-align: center">
          <el-button  type="primary" size="middle" @click="whetherVersionMaintenanceIsDoing" >Enter</el-button>
        </div>

      </div>

      <div style="text-align:center;"></div>
    </div>

    <hktwRoleTips v-model:visible="showHKTWtips" @close="enterSystem" />
  </div>

</template>


<script>
  import store from "@/store";
  import router from "@/router";
  import maintenanceUrl from "@/url.js";
  import hktwRoleTips from "@/components/tips/index.vue";


  export default {
    name:'switchRole',
    props:{},

    components: {
      hktwRoleTips,
    },
    data(){
      return{
        VersionMaintenceResult:true,
        versionMaintenanceValidationUrl:maintenanceUrl.versionMaintenanceUrl,
        currentRole:'',
        roleList:[],
        username : localStorage.getItem("username"),
        dataLoading:false,
        currentRoleKey:'',
        environment: window.baseSSO.environment,
        showHKTWtips: false,
        firstUrl: "/home",
      }
    },
    created(){

      // let rolesStr = localStorage.getItem("roles");
      // 显示用value值
      let rolesStr =JSON.parse(localStorage.getItem("allRoles")) ;
      let arr = []
      for(var key in rolesStr){
        arr.push(rolesStr[key])
      }
      // let roles = JSON.parse(rolesStr);
      // this.roleList = roles;
      this.roleList = arr;   //这些是value
      // console.log(this.baseUrl)
      let userInfo = localStorage.getItem("userInfo");
      let user = JSON.parse(userInfo);
      this.currentRoleKey = user.role;
      for(var key in rolesStr){
        if(key==this.currentRoleKey){
          this.currentRole = rolesStr[key]  //这个存value值
        }
      }
      // this.currentRole = user.role;


      document.body.style.backgroundColor = '#222d32';
    },
    methods:{
      getRedirectAfterLogin(defaultUrl) {
        const redirectUrl = window.sessionStorage.getItem('redirectAfterLogin');
        const ignoreRedirectPaths = ['/login', '/switch-role', '/logout', '/version-maintenance'];
        window.sessionStorage.removeItem('redirectAfterLogin');

        if (
          redirectUrl &&
          redirectUrl.indexOf('/') === 0 &&
          redirectUrl.indexOf('//') !== 0 &&
          ignoreRedirectPaths.indexOf(redirectUrl.split('?')[0]) === -1
        ) {
          return redirectUrl;
        }

        return defaultUrl || '/home';
      },
      // HKTW Role 新增 Pop up Notification
      getHKTWRoleTips() {
        return new Promise(resolve => {
          this.http
          .get(`${this.$baseHKTW}/notice/notice-popup`)
          .then((res) => {
            if (res && res.data && res.data.object && res.data.object.isShow) {
              this.showHKTWtips = res.data.object.isShow;
            } else {
              this.enterSystem();
            }
            resolve(true);
          })
          .catch((err) => {
            resolve(true);
            this.enterSystem();
            console.log(err);
          });
        })
      },
      enterSystem() {
        this.showHKTWtips = false;
        parent.location.href = this.firstUrl;
      },
      changeCurrent(e){
        // console.log(e,'change')
        let rolesStr =JSON.parse(localStorage.getItem("allRoles")) ;
        for(var key in rolesStr){
          if(rolesStr[key]==e){
            this.currentRole = rolesStr[key]  //这个存value值
            this.currentRoleKey = key
            localStorage.setItem("currentRole",this.currentRoleKey);
            let userInfo = localStorage.getItem("userInfo");
            let user = JSON.parse(userInfo);
            user.role = this.currentRoleKey;
            localStorage.setItem("userInfo",JSON.stringify(user));
          }
        }
      },
      //在用户选择角色之后，点击登录按钮
      //需要向后端确认是否在进行页面维护，如页面在维护则无法进入系统
      //跳转到维护页面
      whetherVersionMaintenanceIsDoing(){
        let that = this
        let url = this.baseUrl+this.versionMaintenanceValidationUrl
        this.http.get(url).then(resp=>{
          let data = resp.data
          that.VersionMaintenceResult = data.result
        })
        .then(()=>{
          let res = that.VersionMaintenceResult
          if(!res){
            parent.location.href = "/version-maintenance"
          }else if(res){
            //非维护期间。对admin用户采用SSOValidationUser认证

           //qa或其他环境要放开，本地不放开
           /*if(this.currentRole === 'admin'){
              if(baseSSO.environment !== 'local'){
                console.log(this.currentRole)
                //建立sso认证，跳转到login进行认证
                window.localStorage.setItem('source_login','ssoValidationUser')
                parent.location.href = '/login'
                return
              }
            }*/
            this.toTargetPage();
          }
        })
      },
      toTargetPage(){
        let userInfo = localStorage.getItem("userInfo");
        let user = JSON.parse(userInfo);
        // user.role = this.currentRole;
        user.role = this.currentRoleKey;

        localStorage.setItem("userInfo",JSON.stringify(user));
        // localStorage.setItem("currentRole",this.currentRole);
        localStorage.setItem("currentRole",this.currentRoleKey);
        this.dataLoading = true;
        let params = {};
        // params.roleName = this.currentRole;
        params.roleName = this.currentRoleKey;
        let roleUrl = this.baseAcsUrl + '/acs/role-function/get-firstUrl-by-role'  ;
        this.http.get(roleUrl,params).then(resp =>{
          let cmrAuthUrl = `${this.baseCmrUrl}/v1/userAuthorizationLogin`;
          console.info('[AUTH_EXPIRE_CHECK] CMR authorization start after role switch', {
            url: cmrAuthUrl,
            roleName: this.currentRoleKey,
            loginAgeMs: new Date().getTime() - Number(window.localStorage.getItem('login_time'))
          });
          this.http.post(cmrAuthUrl, {}).then(res => {
            console.info('[AUTH_EXPIRE_CHECK] CMR authorization finished after role switch', {
              success: res && res.success,
              roleName: this.currentRoleKey
            });
          }).catch(error => {
            console.warn('[AUTH_EXPIRE_CHECK] CMR authorization failed after role switch, continue flow', {
              status: error && error.response && error.response.status,
              message: error && error.message,
              roleName: this.currentRoleKey
            });
          }).then(() => {
            // 如果没有，就跳转到home页面
            let firstUrl = "/home";
            if(resp.data && resp.data.firstUrl){
              this.firstUrl = resp.data.firstUrl;
            }
            this.firstUrl = this.getRedirectAfterLogin(this.firstUrl);
            this.dataLoading = false;
            // this.getHKTWRoleTips();
            parent.location.href = this.firstUrl;
          });
        }).catch(error =>{

          this.dataLoading = false;
        })


      }
    }




  }
</script>


<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }

  div /deep/ .el-radio__label {
    color: #ccc;
  }
  div /deep/ .el-dialog {
    margin-top: 0 !important;
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  div /deep/ .el-dialog__body {
    padding: 10px 25px 10px !important;
  }

  .login-container {
    background-color: #222d32 !important;
    width: 100%;
    height: 100%;
    position: fixed;
  }

  .btn {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    padding: 4px 10px 4px;
    margin-bottom: 0;
    font-size: 13px;
    line-height: 18px;
    color: #333333;
    text-align: center;
    text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
    vertical-align: middle;
    background-color: #f5f5f5;
    background-image: -moz-linear-gradient(top, #ffffff, #e6e6e6);
    background-image: -ms-linear-gradient(top, #ffffff, #e6e6e6);
    background-image: -webkit-gradient(
        linear,
        0 0,
        0 100%,
        from(#ffffff),
        to(#e6e6e6)
    );
    background-image: -webkit-linear-gradient(top, #ffffff, #e6e6e6);
    background-image: -o-linear-gradient(top, #ffffff, #e6e6e6);
    background-image: linear-gradient(top, #ffffff, #e6e6e6);
    background-repeat: repeat-x;
    filter: progid:dximagetransform.microsoft.gradient(startColorstr=#ffffff, endColorstr=#e6e6e6, GradientType=0);
    border-color: #e6e6e6 #e6e6e6 #e6e6e6;
    border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
    border: 1px solid #e6e6e6;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.05);
    -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    *margin-left: 0.3em;
  }

  .btn:hover,
  .btn:active,
  .btn.active,
  .btn.disabled,
  .btn[disabled] {
    background-color: #e6e6e6;
  }

  .btn-large {
    padding: 9px 14px;
    font-size: 15px;
    line-height: normal;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }

  .btn:hover {
    color: #333333;
    text-decoration: none;
    background-color: #e6e6e6;
    background-position: 0 -15px;
    -webkit-transition: background-position 0.1s linear;
    -moz-transition: background-position 0.1s linear;
    -ms-transition: background-position 0.1s linear;
    -o-transition: background-position 0.1s linear;
    transition: background-position 0.1s linear;
  }

  .btn-primary,
  .btn-primary:hover {
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
    color: #ffffff;
  }

  .btn-primary.active {
    color: rgba(255, 255, 255, 0.75);
  }

  .btn-primary {
    background-color: #4a77d4;
    background-image: -moz-linear-gradient(top, #6eb6de, #4a77d4);
    background-image: -ms-linear-gradient(top, #6eb6de, #4a77d4);
    background-image: -webkit-gradient(
        linear,
        0 0,
        0 100%,
        from(#6eb6de),
        to(#4a77d4)
    );
    background-image: -webkit-linear-gradient(top, #6eb6de, #4a77d4);
    background-image: -o-linear-gradient(top, #6eb6de, #4a77d4);
    background-image: linear-gradient(top, #6eb6de, #4a77d4);
    background-repeat: repeat-x;
    filter: progid:dximagetransform.microsoft.gradient(startColorstr=#6eb6de, endColorstr=#4a77d4, GradientType=0);
    border: 1px solid #3762bc;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.5);
  }

  .btn-primary:hover,
  .btn-primary:active,
  .btn-primary.active,
  .btn-primary.disabled,
  .btn-primary[disabled] {
    filter: none;
    background-color: #4a77d4;
  }

  .btn-block {
    width: 100%;
    display: block;
  }

  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -o-box-sizing: border-box;
    box-sizing: border-box;
  }

  html {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  /deep/ .login {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 500px;
    height: 300px;
    border: 1px;
    color:green
  }

  .login h1 {
    color: #fff;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    letter-spacing: 1px;
    text-align: center;
  }

  input {
    width: 100%;
    margin-bottom: 10px;
    background: rgba(0, 0, 0, 0.3);
    border: none;
    outline: none;
    padding: 10px;
    font-size: 13px;
    color: #fff;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    box-shadow: inset 0 -5px 45px rgba(100, 100, 100, 0.2),
    0 1px 1px rgba(255, 255, 255, 0.2);
    -webkit-transition: box-shadow 0.5s ease;
    -moz-transition: box-shadow 0.5s ease;
    -o-transition: box-shadow 0.5s ease;
    -ms-transition: box-shadow 0.5s ease;
    transition: box-shadow 0.5s ease;
  }

  input:focus {
    box-shadow: inset 0 -5px 45px rgba(100, 100, 100, 0.4),
    0 1px 1px rgba(255, 255, 255, 0.2);
  }

</style>



// WEBPACK FOOTER //
// src/view/switch_role.vue